<template>
  <div id="wrap">
    <div id="box">
      <div id="marquee" v-html="text"></div>
      <!-- <div id="copy" v-html="text"></div> -->
    </div>
    <div id="node" v-html="text"></div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex'
  export default {
    props: ['lists'], // 父组件传入数据， 数组形式 [ "连雨不知春去"，"一晴方觉夏深"]
    data() {
      return {
        text: '', // 数组文字转化后的字符串
        nowTime: null,
        gardenDate: '', // 小区有效期,
        gardenDateTimestamp: '', // 小区有效期时间戳,
        nowDate: '', // 当前时间戳,
      }
    },
    computed: {
      ...mapGetters({
        gardenId: 'gardenId',
        userGardenList: 'userGardenList'
      }),
      gardenId1() {
        return this.gardenId
      }
    },
    watch: {
      gardenId1(newData, oldData) {
        if (newData == 0) {
          clearInterval(this.nowTime)
          this.nowTime = null
          this.text = ''
        } else {
          clearInterval(this.nowTime)
          this.nowTime = null
          this.getRacNotice()
          this.getDate(newData)
          this.text = ''
        }
      },
      gardenDateTimestamp(newVal, oleVal) {
        // if ((newVal > this.nowDate) && ((newVal - 25920000000) < this.nowDate)) {
        //   console.log('快到期了')
        //   this.text = '<span style="margin-left:20px;">【信息公告】此项目即将到期</span>'
        // }
      },
    },
    methods: {
      move() {
        // 获取文字text 的计算后宽度  （由于overflow的存在，直接获取不到，需要独立的node计算）
        let width = document.getElementById('node').getBoundingClientRect().width
        let box = document.getElementById('box')
        // let copy = document.getElementById('copy')
        // copy.innerHtml = this.text // 文字副本填充
        box.style.width = (width + 600) + 'px'
        let distance = 0 // 位移距离
        // 设置位移
        this.nowTime = setInterval(function () {
          distance = distance - 0.4
          // 如果位移超过文字宽度，则回到起点
          if (-distance >= width) {
            distance = document.getElementById('wrap').getBoundingClientRect().width
          }
          box.style.transform = 'translateX(' + distance + 'px)'
        }, 10)
        let width1 = (document.body.clientWidth) / 2
        let width2 = (document.body.clientWidth) / 2.5
        if (document.body.clientWidth > 1500) {
          document.getElementById('wrap').style.width = width1 + 'px'
        } else {
          document.getElementById('wrap').style.width = width2 + 'px'
        }
      },
      // 获取跑马灯通知
      getRacNotice() {
        let loading = this.$loading()
        this.$get(`/racNoticeBySendType?gardenId=${this.gardenId}&sendType=3`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res.data)
              let fontLists = []
              // 判断是否快过期
              if ((this.gardenDateTimestamp > this.nowDate) && ((this.gardenDateTimestamp - 2592000000) < this
                  .nowDate)) {
                console.log('快到期了')
                this.text = '<span style="margin-left:20px;">【信息公告】此项目即将到期，请联系管理人员</span>'
              }
              if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                  if (res.data[i].url) {
                    let a = '<span style="margin-left:20px;">【信息公告】</span><a style="color:#3A8DFC" href="' + res.data[i].url + '" target="_blank">' + res.data[i].title + '</a>'
                    fontLists.push(a)
                  } else {
                    let a = '<span style="margin-left:20px;">【信息公告】</span>' + res.data[i].title
                    fontLists.push(a)
                  }
                }
                for (let i = 0; i < fontLists.length; i++) {
                  this.text += ' ' + fontLists[i]
                }
              } else {
                this.text = this.text
              }
              console.log(this.text)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取项目到期时间
      getDate(newData) {
        if (newData == 0) {
          this.gardenDate = ''
        } else {
          var obj = this.userGardenList.find(function (obj) {
            return obj.id == newData
          })
          console.log(obj)
          if (obj.gardenValid) {
            this.gardenDate = obj.gardenValid
            var date = new Date(this.gardenDate)
            var time = date.getTime()
            this.gardenDateTimestamp = time // 项目到期日期
            console.log('项目有效期===' + this.gardenDateTimestamp)
          } else {
            this.gardenDate = ''
          }
        }
      },
      // 获取当前时间
      getDateNow() {
        var date = new Date()
        var time = date.getTime()
        this.nowDate = time
        console.log('当前时间戳===' + time)
      },
    },
    // 把父组件传入的arr转化成字符串
    mounted() {
      this.getDateNow()
      this.getDate(this.gardenId)
      this.getRacNotice()
    },
    // 更新的时候运动
    updated() {
      this.move()
    }
  }
</script>
<style scoped>
  /*样式的话可以写*/
  #wrap {
    overflow: hidden;
    background: white;
    margin-left: 10vw;
    /* max-width: 50vw; */
    min-width: 30vw;
    color: #00b1c3;
  }

  #box {
    /* width: 1000%; */
  }

  #box div {
    float: left;
  }

  #marquee {
    margin: 0 30px 0 0;
  }

  #node {
    position: absolute;
    z-index: -99;
    top: -99px;
  }
</style>